export const ROUTE_PATH = '/purchase-history';

export const FEATURE_NAME = 'purchaseHistoryPage';
